let inviteFromFirstRead = '';

function readInviteParam() {
  if (typeof window === 'undefined') return '';
  const code = new URLSearchParams(window.location.search).get('invite');
  return code ? code.trim().toUpperCase() : '';
}

// The signup screen strips ?invite= after paint. Keep the code from the
// first read so a later render does not bring the trial box back.
function rememberTeamInvite() {
  const current = readInviteParam();
  if (current) inviteFromFirstRead = current;
  return inviteFromFirstRead;
}

function resetRememberedTeamInvite() {
  inviteFromFirstRead = '';
}

export { rememberTeamInvite, resetRememberedTeamInvite };
